<div class="parentcard border rounded">
  <!-- Updated header section -->
  <div class="page-header">
    <h4>
      <i class="bi bi-file-earmark-code me-2"></i>
      Available Scripts
    </h4>
  </div>

  <div class="section table-responsive">
      <input
        type="text"
        class="form-control"
        name="searchFile"
        [(ngModel)]="searchFile"
        placeholder="Search script name..."
        (keyup)="onSearchChange($event)"
        (ngModelChange)="filteredScript()"
      />
    <table
      class="table table-bordered table-striped table-hover mt-2 rounded"
    >
      <thead>
        <tr class="align-middle">
          <th class="text-center rowhead">#</th>
          <th colspan="1">Script Name</th>
          <th>Created By</th>
          <th>Last Modified</th>
          <th class="text-center viewhead">View Script</th>
          <th class="text-center viewhead">View Validation</th>
          <th class="text-center viewhead">View Metadata</th>
          <!-- <th class="text-center">Generate Data</th> -->
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let script of pagedScripts;
            let i = index
          "
          class="align-middle"
        ><!--| searchName : searchString;-->
          <td class="text-center rowhead">{{ (currentPage - 1 ) * pageSize + i + 1 }}</td>
          <td>{{ script.name }}</td>
          <td>{{ script.metadata.created_by }}</td>
          <td>{{ script.last_modified }}</td>
          <td class="text-center viewhead"><i class="bi bi-eye pl-3"(click)="viewFile(script.name, 'script')"></i></td>
          <td class="text-center viewhead"><i class="bi bi-eye pl-3"(click)="viewFile(script.name, 'validation')"></i></td>
          <td class="text-center viewhead"><i class="bi bi-eye pl-3"(click)="viewMetadataFile(script.metadata.metadata_filepath)"></i></td>
          <!-- <td><button class="btn btn-block btn-default text-center"><i class="bi bi-arrow-right-square"></i></button></td> -->
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example" *ngIf="totalPages > 1">
      <ul class="pagination justify-content-end">
        <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
          <a class="page-link" (click)="previousPage()" tabindex="-1" aria-disabled="true"><span aria-hidden="true">&laquo;</span></a>
        </li>
        <li class="page-item" *ngFor="let page of pages" [ngClass]="{active: page === currentPage}">
            <a class="page-link" (click)="goToPage(page)">{{page}}</a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
          <a class="page-link" (click)="nextPage()"><span aria-hidden="true">&raquo;</span></a>
        </li>
      </ul>
    </nav>
  </div>


</div>

